import {Mental} from "../Mental";
import {TimelineLite, TimelineMax} from "gsap";
import {MentalS2XWaysAnim} from "./MentalS2XWaysAnim";

export class S2XWaysFeature extends PIXI.Container {
    public _numberOfXWaysPlayedOnReel1: number[] = [0, 0, 0, 0]; // added  this to handle multi xways  split  on reel 1
    public _numberOfXWaysPlayedOnReel3: number[] = [0, 0, 0, 0];
    private _xWaysAnim1: MentalS2XWaysAnim[] = [];
    private _xWaysAnim3: MentalS2XWaysAnim[] = [];

    constructor() {
        super();
        this.init();
    }

    public showXWaysLogoBg(reelId: number, symId: number, index: number): TimelineMax {
        const tl: TimelineMax = new TimelineMax();

        if (reelId === 1) {
            tl.add(this._xWaysAnim1[index].playOpeningAnimationS2(symId, index));
        } else {
            tl.add(this._xWaysAnim3[index].playOpeningAnimationS2(symId, index));
        }
        return tl;
    }

    public expandXWaysPresentation(reelId: number, symId: number, index: number): TimelineMax {
        const tl: TimelineMax = new TimelineMax();

        if (reelId === 1) {
            this._numberOfXWaysPlayedOnReel1[index] = 1;
            tl.add(this._xWaysAnim1[index].playExpandAnimationS2(symId, index));
            if (Mental.model.gameData.xWaysPlayed[0]) {
                for (let i: number = 0; i < index; i++) {
                    if (index !== i) {
                        tl.add(this._xWaysAnim1[i].resizeS2xWaysBg(), 0);
                    }
                }
            }
        } else {
            this._numberOfXWaysPlayedOnReel3[index] = 1;
            tl.add(this._xWaysAnim3[index].playExpandAnimationS2(symId, index));
            if (Mental.model.gameData.xWaysPlayed[1]) {
                for (let i: number = 0; i < index; i++) {
                    if (index !== i) {
                        tl.add(this._xWaysAnim3[i].resizeS2xWaysBg(), 0);
                    }
                }
            }
        }
        return tl;
    }

    public hideAllXWaysOverlays(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        for (let i: number = 0; i < 4; i++) { // hide all indexes overlay
            tl.add(this._xWaysAnim1[i].hideXWaysOverlayAnim(), 0);
            tl.add(this._xWaysAnim3[i].hideXWaysOverlayAnim(), 0);
        }

        return tl;
    }

    public getXWaysAnimBgYPos(reelId: number, index: number, fromEnhancer: boolean): number {
        if (reelId === 1) {
            return this._xWaysAnim1[index].getBGCenterYPos(fromEnhancer);
        } else {
            return this._xWaysAnim3[index].getBGCenterYPos(fromEnhancer);
        }
    }

    public getXWaysAnimBgHeight(reelId: number, index: number): number {
        if (reelId === 1) {
            return this._xWaysAnim1[index].getBGHeight();
        } else {
            return this._xWaysAnim3[index].getBGHeight();
        }
    }

    public resizeXWaysOverlay(index: number, reelId: number, tl: TimelineLite, isOnEnhancer: boolean = false): void {
        const xWaysPlayed: boolean = reelId == 1 ? Mental.model.gameData.xWaysPlayed[0] : Mental.model.gameData.xWaysPlayed[1];
        const xWaysAnim: MentalS2XWaysAnim[] = reelId == 1 ? this._xWaysAnim1 : this._xWaysAnim3;
        if (xWaysPlayed) {
            for (let i: number = 0; i < index; i++) {
                if (index !== i || isOnEnhancer) {
                    tl.add(xWaysAnim[i].resizeS2xWaysBg(isOnEnhancer), 0);
                }
            }
        }
    }

    public resizeXWaysOverlayWhenE2isClosed(index: number, reelId: number, tl: TimelineLite, isOnEnhancer: boolean = false, specialE2ClosedCase: boolean = false, onlyForIndex: number = -1): void {
        const xWaysPlayed: boolean = reelId == 1 ? Mental.model.gameData.xWaysPlayed[0] : Mental.model.gameData.xWaysPlayed[1];
        const xWaysAnim: MentalS2XWaysAnim[] = reelId == 1 ? this._xWaysAnim1 : this._xWaysAnim3;
        if (xWaysPlayed) {
            for (let i: number = 0; i < index; i++) {
                tl.add(xWaysAnim[i].resizeS2xWaysBg(isOnEnhancer, false, (i === onlyForIndex && specialE2ClosedCase)), 0);
            }
        }
    }

    public resizeXWaysOverlayFromXSplit(allS2FeatureLength: number, index: number, reelId: number, tl: TimelineLite): void {
        allS2FeatureLength = allS2FeatureLength ? allS2FeatureLength : 1;
        const xWaysPlayed: boolean = (reelId === 1) ? Mental.model.gameData.xWaysPlayed[0] : Mental.model.gameData.xWaysPlayed[1];
        const xWaysAnim: MentalS2XWaysAnim[] =( reelId === 1) ? this._xWaysAnim1 : this._xWaysAnim3;
        if (xWaysPlayed) {
            for (let i: number = 0; i < allS2FeatureLength; i++) {
                tl.add(xWaysAnim[i].resizeS2xWaysBg(false, index === i), 0);
            }
        }
    }

    public doTint(tint: number): void {
        for (let i: number = 0; i < 4; i++) {
            this._xWaysAnim1[i].doTint(tint);
            this._xWaysAnim3[i].doTint(tint);
        }
    }

    /**
     * function to create graphics and animations
     * @private
     */
    private init(): void {
        const mask1: PIXI.Container = Mental.reelArea.getReel(1).layerSet.layers[1].mask as PIXI.Container;
        const mask3: PIXI.Container = Mental.reelArea.getReel(3).layerSet.layers[1].mask as PIXI.Container;

        // added this loop to create 4 animation for each reel.
        for (let i: number = 0; i < 4; i++) {
            const xWaysAnim1: MentalS2XWaysAnim = new MentalS2XWaysAnim(1, () => {
            });
            this.addChild(xWaysAnim1)
            xWaysAnim1.mask = mask1;
            this._xWaysAnim1.push(xWaysAnim1);

            const xWaysAnim3: MentalS2XWaysAnim = new MentalS2XWaysAnim(3, () => {
            });
            this.addChild(xWaysAnim3)
            xWaysAnim3.mask = mask3;
            this._xWaysAnim3.push(xWaysAnim3);
        }
        this.position.set(72, 189); //144/2 , 90+99
    }
}